<template>
  <div>
    <role-index />
  </div>
</template>

<script>
// 获取接口地址
import RoleIndex from '../components/role/roleIndex.vue'

export default {
  name: 'Jsgl',
  components: {
    RoleIndex
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
